module.exports = __webpack_public_path__ + "static/media/github.fec7da6d.svg";